import { render, staticRenderFns } from "./WorkDialog.vue?vue&type=template&id=99df53ec&scoped=true"
import script from "./WorkDialog.vue?vue&type=script&lang=js"
export * from "./WorkDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkDialog.vue?vue&type=style&index=0&id=99df53ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df53ec",
  null
  
)

export default component.exports